import ApiServer from "../ApiServer.ts";
import * as amplify from "../util/amplify.ts";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as Html from "../util/Html.ts";
import {familyPickOther} from "../modal/familypicker.ts";
import {EventStore} from "../server/EventStore.ts";
import { checkEventLimitOntry, modalEventHardLimitReached, modalOtherCircleEventHardLimitReached } from "./calendarclean.ts";
import "../util/MemberOrder.ts"
import { translateEvent } from "../specialdays/common_specialdays.ts";
import { openspecialdayeditmodal } from "../specialdays/ui_specialdays.ts";
import Icons, { SvgFile } from "../svg/Icons.ts";
import { aiImportCredits } from "./aiimport.ts";
import { isVoiceAvailable } from "./aiimport_voice.ts";
import * as segment from "../tracking-segment.ts";

  var
    currentUpdateCall;

  function updateErrorHandler(err){
    if(err.FiZClassId==="23"){
      modal.alert("event.FizApiDistinctOccurenceIntersectException");
    }else{
      modal.alert("event.updateError");
    }
  }

  const wholeSeriesIds = new Set<string>();
  ApiServer["custom.evtupdate"] = async function(form,success){
    const tracked = segment.formEventTracker(form);
    function doit(option){
      modal.closeDomModal()
      ApiServer.evtupdate.prepare(option)(form,function(this: any, ...args){
        tracked();
        return success?.apply(this,args);
      },updateErrorHandler)
    }
    ApiServer.evtupdateoption(form,async function(options){
      if(options.length<2){
        doit(options[0])
      }else if(wholeSeriesIds.has(form.metaId?.value) && options.indexOf('All')!==-1){
        doit('All')
      }else{
        const opt = await modal.askAsPromise({
          title:'event.updaterecurringtitle',
          message:'event.updaterecurringtext',
          button:options.map(opt=>{return {value:opt,title:'event.updaterecurring'+opt}})
        });
        if(opt) doit(opt)
      }
    });
  };
  ApiServer["custom.evtcreate"] = ApiServer.evtcreate.prepare(function(){
    amplify.publish('eventCreated')
    EventStore.invalidate(metaId=>metaId.startsWith('calendar/'))
  });

  ApiServer["custom.evtcreateotherscope"] = async function(form){
    let
      familyId = form.scope.value,
      familyName = FwDatas.getFamily(familyId).name,
      TPL = await import("../modal/snack.mustache")
    try{
      await ApiServer.evtcreate.prepare(function(){
        amplify.publish('eventCreated')
        EventStore.invalidate(metaId=>metaId.startsWith('calendar/'));
        modal.snack(TPL, { html: i18n.get('event.createdothercircle','<u data-fw-onclick="changetofamily|'+familyId+'">'+Html.escape(familyName)+'</u>') },6000)
      })(form);
    }catch(e){

    }


  }
  /**
   * The events of an AI import reviewed in its success modal (FWWEB-1846): a recurring one is edited as a whole series,
   * without the question of the occurrences to update
   * @returns the function forgetting them, when the review is over
   */
  export function editAsWholeSeries(metaIds :string[]){
    metaIds.forEach(metaId=>wholeSeriesIds.add(metaId));
    return ()=>metaIds.forEach(metaId=>wholeSeriesIds.delete(metaId));
  }
  export function editEventOption(option){
    currentUpdateCall({option:option});
  }

  function initEditModal(){
    const accountId = String(FwDatas.getAccountId());

    document.querySelectorAll<HTMLSelectElement>("select[name='attendee.$i.accountId']").forEach(select => {
      const form = select.closest('form');

      const handleChange = () => {
        let amIAttendee = select.value.includes(accountId);
        const reminderInput = form.querySelector<HTMLInputElement>('input[name="reminder"]');
        const relatedSelects = reminderInput?.parentElement?.querySelectorAll('select');

        if (reminderInput) {
          reminderInput.disabled = !amIAttendee;

          relatedSelects?.forEach(sel => {
            sel.disabled = !amIAttendee;
          });
        }
      };

      select.addEventListener('change', handleChange);
      handleChange(); // initial trigger
    });
  }

/*
  Function: createEvent()
  Open the modal window to create a new event
*/
export async function createEvent(startDate,endDate,allDay,calendar?, resource?){

  var [
    EVENT_EDIT_TEMPLATE,
    TIMETABLEEVENT_EDIT_TEMPLATE,
    doOpen
  ] = await Promise.all([
      import("../modal/event_edit.mustache"),
      import("../timetable/timetableevent_edit.mustache"),
      calendar===undefined?checkEventLimitOntry():true //we do not check for timetable
    ]);

  if(doOpen){
    if(!endDate){
      endDate = new Date(startDate+30*60000);
    }

    var
      settings = FwDatas.getSettingsPerFamily();


    modal.openDomModal(calendar && calendar.timetable && !calendar.timetable.isOneTime?TIMETABLEEVENT_EDIT_TEMPLATE:EVENT_EDIT_TEMPLATE,{
      toAll:resource===undefined,
      attendees:resource===undefined?undefined:[{accountId:resource.id}],
      allDay:!!allDay,
      calendar:calendar,
      start:startDate,
      end:endDate,
      reminder0:{simple:settings.defaultReminderType==='NONE'?"":(allDay?"MINUTE-0":settings.defaultReminderUnit+"-"+settings.defaultReminderValue)},
      recurrencyDescriptor:new ApiServer.types.RecurrencyDescriptor({recurrency:'NONE'}),
      aiImportCredits:aiImportCredits(),
      aiImportVoice:isVoiceAvailable()

    });
    initEditModal();
  }else{
    modalEventHardLimitReached()
  }
}

export async function editEvent(event){
  if(['SPECIAL_DAYS','ANNIVERSARY','BIRTHDAY','BIRTHDAY_ACCOUNT','BIRTHDAY_CUSTOM'].indexOf(event.eventType)!==-1){
    modal.closeDomModal()
    openspecialdayeditmodal(FwDatas.get(event.eventMasterId))

  }else{
    var
      [EVENT_EDIT_TEMPLATE,TIMETABLEEVENT_EDIT_TEMPLATE] = await Promise.all([
        import("../modal/event_edit.mustache"),
        import("../timetable/timetableevent_edit.mustache")
      ]);

    modal.closeDomModal();
    modal.openDomModal(
      event.calendar && event.calendar.timetable && !event.calendar.timetable.isOneTime?TIMETABLEEVENT_EDIT_TEMPLATE:EVENT_EDIT_TEMPLATE,
      event
    );
    initEditModal();

  }
}


export async function viewEventDetails(event,isDisplayInTimetable = false){
  event.buildDisplayInCalendar();
  event.isDisplayInTimetable = isDisplayInTimetable;
  let EVENT_DETAILS_TEMPLATE;
  if(['SPECIAL_DAYS','ANNIVERSARY','BIRTHDAY','BIRTHDAY_ACCOUNT','BIRTHDAY_CUSTOM'].indexOf(event.eventType)!==-1){
	  EVENT_DETAILS_TEMPLATE = await import("../specialdays/specialdays_modal.mustache")
    var svgFile : SvgFile =  ({
      'SPECIAL_DAYS':Icons.specialdays.illustration_type_celebration,
      'ANNIVERSARY':Icons.specialdays.illustration_type_anniversary
    }[event.eventType] || Icons.specialdays.illustration_type_birthday)
    event.cover = await svgFile.toDataUrl()
    event = translateEvent(event)
  }else{
    EVENT_DETAILS_TEMPLATE = await import("../modal/event_view.mustache")
  }
  if(event.externalImportId){
    try{
      var importBean = await ApiServer.metaget(event.externalImportId)
      event.externalImportAI = importBean.importType === 'EVENT_BY_INBOX'
      event.externalImportICAL = importBean.importType === 'EVENT_BY_ICAL'
      event.externalImportAIUpload = importBean.importType === 'EVENT_BY_AI_UPLOAD'

    }catch(e){
      console.log(e)
    }
  }
  return modal.openDomModal(
    EVENT_DETAILS_TEMPLATE,
    event
  );
}
amplify.subscribe("eventCreated eventUpdated eventDeleted contactUpdated",function(){
  modal.closeDomModal();
});

Html.registerDom({
  calediterror(metaId){
    var calendar = FwDatas.get(metaId);
    if(calendar.mine){
      var isOutlook = metaId.indexOf("extCalendarOutlook")===0;

      modal.askAsPromise({
        title:"calendars.calerror.modaltitle",
        lottie:"images/lottie/robot.json",
        message:calendar.errorMessage,
        copyable:i18n.get("calendars.calerror.errorcode",calendar.errorCode),
        button:[
          {title:'actions.reconnect',action:isOutlook?"outlookconnect":"googleconnect"}
        ]
      })
    }else{
      modal.askAsPromise({
        title:"calendars.calerror.modaltitle",
        lottie:"images/lottie/robot.json",
        message:calendar.errorMessage,
        button:[
          {title:'actions.gotit'}
        ]
      })
    }
  },
  caledit(metaId){
    import("../modal/cal_edit.mustache").then(function(TPL){
      var calendar = FwDatas.get(metaId);
      if(metaId.indexOf('calendarMealPlanner')===0){
        ApiServer.mpsettingsget(function(mpSettings){
          calendar.mpSettings = mpSettings;
        })
      }
      if(calendar.icalAble){
        calendar.icalui = true;
        ApiServer.evticalvisibleurl(false,metaId,function(url){
          calendar.icalurl = url;
        })
      }
      if(metaId.indexOf('calendarTimetable')===0){
        calendar = Object.assign({},calendar,{rights:{canUpdate:true}})
      }
      ApiServer.aftergroup(function(){
        modal.openDomModal(TPL,calendar);
      })

    });
  },
  evtclick(id){
    if(id.indexOf('task')===0){
      Html.trigger(this,"taskview",[id])
    }else{
      var evtFw = FwDatas.get(id);
      if(evtFw){
        viewEventDetails(evtFw)
      }else{
        ApiServer.evtget(id,viewEventDetails);
      }
    }


  },
  async eventcopy(){
    let
      eventId = Html.getDomMetaId(this),
      picked = await familyPickOther(i18n.get('actions.copytopicker'));

    if(picked){
      if(!await checkEventLimitOntry(picked.metaId)){
        modalOtherCircleEventHardLimitReached()
        return;
      }

      var copy = new ApiServer.types.IEvent(Object.assign(FwDatas.get(eventId).json,{metaId:null}));
      copy.scope = picked.metaId;
      copy.calendarId = null;
      copy.toAll = true;
      copy.family = picked
      editEvent(copy)
    }

  },
  async timetabledelete(metaId){
    if(!metaId) metaId = Html.getDomMetaId(this);
    var timetable = FwDatas.get(metaId)
    const answer = await modal.askAsPromise({
      title:i18n.get("timetable.deletetitle",timetable.name),
      message:'timetable.confirmdelete',
      button:[
        {title:"actions.delete",class:"negative",value:"delete"},
        {title:"actions.cancel",class:"secondary"}
      ]
    });
    if(answer === "delete"){
      ApiServer.metadelete(metaId);
      amplify.publish("timetableUpdated")
    }

  },
  caledu(type){
    if(type==='private'){
      modal.askAsPromise({
        title:"new_event.private",
        lottie:"images/lottie/face_with_monocle.json",
        message:"new_event.privateexplain",
        button:[{title:'actions.gotit'}]
      })
    }else if(type==='timezonelocal'){
      modal.askAsPromise({
        title:"timezone.localtime",
        lottie:"images/lottie/anim_clock.json",
        message:"timezone.localedu",
        button:[{title:'actions.gotit'}]
      })
    }else if(type==='timezone'){
      modal.askAsPromise({
        title:"timezone.target",
        lottie:"images/lottie/anim_clock.json",
        message:"timezone.targetedu",
        button:[{title:'actions.gotit'}]
      })
    }else{
      throw new Error('Invalid type for caledu|'+type)
    }
  }
})

export function askCalendarUrl(options){
  return modal.askText(Object.assign({},{
    image:"/images/calendar_dialog_subscription_add.svg",
    message:'calendars.calbyurl.text',
    placeholder:'calendars.calbyurl.placeholder',
    sub:'calendars.calbyurl.subtext',
    buttonName:'calendars.calbyurl.button',
    validate:async function(url){
      try{
        return await ApiServer.evtcalcheckurl(url)
      }catch(error){
        let errorKey = {"405":"calendars.calbyurl.error405","406":"calendars.calbyurl.error406"}[(error as any).code]||"calendars.calbyurl.errortext";
        modal.oops(errorKey);
        return false;
      }
    }
  },options))
}